const TOKEN_KEY = "token";

export function clearSession() {
  sessionStorage.clear();
}

function decodeJwtPayload(token) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return JSON.parse(window.atob(padded));
  } catch (error) {
    return null;
  }
}

export function isTokenValid(token = sessionStorage.getItem(TOKEN_KEY)) {
  if (!token) {
    return false;
  }

  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") {
    return false;
  }

  return payload.exp * 1000 > Date.now();
}

export function hasValidSession() {
  return Boolean(sessionStorage.getItem("userId")) && isTokenValid();
}

export function redirectToLogin() {
  clearSession();
  if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
    window.location.replace("/login");
  }
}
